<template>
  <svg
    width="26"
    height="34"
    viewBox="0 0 26 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 18.1071C14.0055 18.1071 14.8281 17.2714 14.8281 16.25C14.8281 15.2286 14.0055 14.3929 13 14.3929C11.9945 14.3929 11.1719 15.2286 11.1719 16.25C11.1719 17.2714 11.9945 18.1071 13 18.1071ZM18.4844 9.75H17.5703V7.89286C17.5703 5.33 15.5228 3.25 13 3.25C10.4772 3.25 8.42969 5.33 8.42969 7.89286H10.1664C10.1664 6.305 11.437 5.01429 13 5.01429C14.563 5.01429 15.8336 6.305 15.8336 7.89286V9.75H7.51562C6.51016 9.75 5.6875 10.5857 5.6875 11.6071V20.8929C5.6875 21.9143 6.51016 22.75 7.51562 22.75H18.4844C19.4898 22.75 20.3125 21.9143 20.3125 20.8929V11.6071C20.3125 10.5857 19.4898 9.75 18.4844 9.75ZM18.4844 20.8929H7.51562V11.6071H18.4844V20.8929Z"
      fill="url(#paint0_linear)"/>
    <path
      d="M5.45703 29.4883C5.45703 29.2878 5.38542 29.1315 5.24219 29.0195C5.10156 28.9076 4.85286 28.7917 4.49609 28.6719C4.13932 28.5521 3.84766 28.4362 3.62109 28.3242C2.88411 27.9622 2.51562 27.4648 2.51562 26.832C2.51562 26.5169 2.60677 26.2396 2.78906 26C2.97396 25.7578 3.23438 25.5703 3.57031 25.4375C3.90625 25.3021 4.28385 25.2344 4.70312 25.2344C5.11198 25.2344 5.47786 25.3073 5.80078 25.4531C6.1263 25.599 6.37891 25.8073 6.55859 26.0781C6.73828 26.3464 6.82812 26.6536 6.82812 27H5.46094C5.46094 26.7682 5.38932 26.5885 5.24609 26.4609C5.10547 26.3333 4.91406 26.2695 4.67188 26.2695C4.42708 26.2695 4.23307 26.3242 4.08984 26.4336C3.94922 26.5404 3.87891 26.6771 3.87891 26.8438C3.87891 26.9896 3.95703 27.1224 4.11328 27.2422C4.26953 27.3594 4.54427 27.4818 4.9375 27.6094C5.33073 27.7344 5.65365 27.8698 5.90625 28.0156C6.52083 28.3698 6.82812 28.8581 6.82812 29.4805C6.82812 29.9779 6.64062 30.3685 6.26562 30.6523C5.89062 30.9362 5.3763 31.0781 4.72266 31.0781C4.26172 31.0781 3.84375 30.9961 3.46875 30.832C3.09635 30.6654 2.8151 30.4388 2.625 30.1523C2.4375 29.8633 2.34375 29.5312 2.34375 29.1562H3.71875C3.71875 29.4609 3.79688 29.6862 3.95312 29.832C4.11198 29.9753 4.36849 30.0469 4.72266 30.0469C4.94922 30.0469 5.1276 29.9987 5.25781 29.9023C5.39062 29.8034 5.45703 29.6654 5.45703 29.4883ZM10.7617 29.9375H8.88281L8.55469 31H7.08984L9.17578 25.3125H10.4648L12.5664 31H11.0938L10.7617 29.9375ZM9.21094 28.8789H10.4336L9.82031 26.9062L9.21094 28.8789ZM14.7852 25.3125L16.0547 29.2695L17.3203 25.3125H19.125V31H17.75V29.6719L17.8828 26.9531L16.5078 31H15.6016L14.2227 26.9492L14.3555 29.6719V31H12.9844V25.3125H14.7852ZM21.3711 29.9453H23.7578V31H20V25.3125H21.3711V29.9453Z"
      fill="url(#paint1_linear)"/>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="13"
        y1="3.25"
        x2="13"
        y2="22.75"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#1C9797"/>
        <stop
          offset="1"
          stop-color="#167979"/>
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="13"
        y1="22"
        x2="13"
        y2="34"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#1C9797"/>
        <stop
          offset="1"
          stop-color="#167979"/>
      </linearGradient>
    </defs>
  </svg>
</template>
